export type StepId =
  | "subjects"
  | "tutoring-options"
  | "tutor-profile"
  | "qualifications"
  | "contact-info"
  | "subscription"
  | "submit";

export type StepDefinition = {
  id: StepId;
  title: string;
  description?: string;
};

export const stepsConfig: StepDefinition[] = [
  { id: "subjects", title: "Subjects", description: "What can you teach?" },
  { id: "tutoring-options", title: "Tutoring options", description: "Online / In person" },
  { id: "tutor-profile", title: "Tutor profile", description: "Title, bio, photo" },
  { id: "qualifications", title: "Qualifications", description: "Your credentials" },
  { id: "contact-info", title: "Contact info", description: "Optional details" },
  { id: "subscription", title: "Subscription", description: "Plan & payment" },
  { id: "submit", title: "Submit", description: "Review & submit" },
];


